<template>
    <div v-if="getCurrentUser" class="table-container">
        <div class="title">Username :  {{ user.username }}</div>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            User Details
                        </th>
                        <th class="text-right">
                            <v-btn
                                v-if="getCurrentUser.role.role === 'ROLE_SUPER_ADMIN'"
                                depressed
                                color="error"
                                @click="deleteUser(user.id)"
                            >Delete this User</v-btn>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="td-header">Id</td>
                        <td>{{ user.id }}</td>
                    </tr>
                    <tr>
                        <td class="td-header">Username</td>
                        <td>{{ user.username }}</td>
                    </tr>
                    <tr>
                        <td class="td-header">Is Active</td>
                        <td>
                            <div :class="[user.active ? 'active' : 'disable']">
                                {{ user.active }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="td-header">Admin</td>
                        <td v-if="user.parent">
                            {{ user.parent.username }}
                        </td>
                        <td v-else>
                            None
                        </td>
                    </tr>
                    <tr>
                        <td class="td-header">Role</td>
                        <td v-if="user.role">
                            {{ user.role.role }}
                        </td>
                        <td v-else>
                            None
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-btn class="edit-btn" @click="editUser(user.id)">
            Edit
        </v-btn>
    </div>
</template>

<script>
    import userService from '@/services/user-service'
    export default {
        data() {
            return {
                user: {}
            }
        },
        computed: {
            getCurrentUser() {
                return this.$store.getters.getCurrentUser
            }
        },
        created() {
            this.fetchUserById(this.$route.params.userId)
        },
        methods: {
            deleteUser(id) {
                userService.deleteUser(id).then(resp => {
                    this.$router.push('/users')
                })
            },
            editUser(id) {
                this.$router.push(`/users/create/${id}`)
            },
            fetchUserById(id) {
                userService.getUserById(id).then(resp => {
                    this.user = resp.data
                })
            }
        }
    }
</script>

<style scoped>
    .title {
        font-size: 1.5rem !important;
        margin-bottom: 10px;
    }

    .edit-btn {
        text-transform: none !important;
        background: #00acd6 !important;
        color: white;
        margin: 15px auto;
        width: 100%;
    }

    .td-header {
        font-weight: bold;
    }

    .active {
        text-align: center;
        border-radius: 5px;
        padding: 5px;
        width: 50px;
        color: white;
        background: green;
        font-weight: 500;
    }

    .disable {
        text-align: center;
        padding: 5px;
        border-radius: 5px;
        color: white;
        width: 50px;
        background: red;
        font-weight: 500;
    }
</style>
